import { QueryFeature } from '../../../../config/queryClient';

enum QueryKey {
  AutomatedAccountsResult = 'AutomatedAccountsWorkflowResult',
}

export const queryKeys = {
  automatedAccountsResults: (clientId: string) => [
    QueryFeature.AutomatedAccount,
    QueryKey.AutomatedAccountsResult,
    clientId,
  ],
};
